(function (app) {

    app.provider("fundingSourceApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        const service = {};

                        //GETs
                        service.getFundingSource = (fundingSourceId) => {
                            return crmApiGateway.get(`/FundingSources/${fundingSourceId}`);
                        };

                        service.getInsuranceAccountFundingSources = (accountId) => {
                            return crmApiGateway.getArray(`/InsuranceAccounts/${accountId}/FundingSources`);
                        }

                        service.getInvestmentAccountFundingSources = (accountId) => {
                            return crmApiGateway.getArray(`/InvestmentAccounts/${accountId}/FundingSources`);
                        }

                        //PUTs
                        service.updateFundingSource = (fundingSourceId, fundingSource) => {
                            return crmApiGateway.put(`/FundingSources/${fundingSourceId}`, fundingSource);
                        };

                        //POSTs
                        service.createFundingSource = (fundingSource) => {
                            return crmApiGateway.post("/FundingSources", fundingSource);
                        };

                        service.deleteFundingSource = (fundingSourceId) => {
                            return crmApiGateway.delete(`/FundingSources/${fundingSourceId}`);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line